import { reactive, watchEffect } from '@vue/composition-api';

import { actions } from '@/controller';
import store from '@/store';
import { prompt } from '@/components/Prompt';
import { Menu, UserLevel } from '@/types';
import { filterMenus } from '@/filemenu/utils';
import { browseDatasetMenu, generateDatasetMenu, uploadVideoFileMenu, manageVideoFilesMenu } from './state';

const browseDataset: Menu = {
  text: 'Browse Datasets',
  click: () => { browseDatasetMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.User, UserLevel.Userhigh],
};
const closeDataset: Menu = {
  text: 'Close Current Dataset',
  click: async () => {
    const choice = await prompt.open({
      title: 'Close this dataset?',
      message: 'Are you sure you want to close this dataset? Any unsaved changes will be lost.',
      positiveText: 'Confirm',
      negativeText: 'Cancel',
    });

    if (choice) {
      actions.clearDataset();
    }
  },
  disabled: true,
  disallowed: [],
};
const generateDataset: Menu = {
  text: 'Generate Dataset',
  click: () => { generateDatasetMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.User, UserLevel.Userhigh],
};
const uploadVideoFile: Menu = {
  text: 'Upload Video File',
  click: () => { uploadVideoFileMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.Annotator],
};
const manageVideoFiles = {
  text: 'Manage Video Files',
  click: () => { manageVideoFilesMenu.value = true; },
  disabled: false,
  disallowed: [UserLevel.Scorer, UserLevel.Annotator],
};

// Order will be preserved
const allMenus = [
  browseDataset,
  closeDataset,
  generateDataset,
  uploadVideoFile,
  manageVideoFiles,
];

export const menu = reactive({
  text: 'File',
  menu_width: 200,
  menu: [] as Menu[],
});

// Enable/disable menu items based on user level
watchEffect(() => {
  // Mark as enabled/disabled as necessary
  closeDataset.disabled = store.state.dataset.datasetId === null;

  // Filter allowed menus
  menu.menu = filterMenus(allMenus);
});
